export default __webpack_public_path__ + "static/media/Flow_er.cd166989.svg";